import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { IconArrowRight } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import axios from 'axios';

// SVG Bileşenleri
import SvgMeeting from '../components/svg/SvgMeeting';
import SvgKids from '../components/svg/SvgKids';
import SvgLearning from '../components/svg/SvgLearning';
import SvgAcademyCall from '../components/svg/SvgAcademyCall';
import SvgTest from '../components/svg/SvgTest';

function Home() {
    const [sponsors, setSponsors] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Sponsor verilerini çeken fonksiyon
        const fetchSponsors = async () => {
            try {
                const response = await axios.get("https://admin.maviada.co/api/sponsor");
                setSponsors(response.data?.data || []);
            } catch (error) {
                console.error("Sponsor verileri alınamadı:", error);
            } finally {
                setLoading(false);
            }
        };

        // İlk çağrıyı hemen yap
        fetchSponsors();

        // 60 saniyede bir veri çekme işlemini tekrar et
        const intervalId = setInterval(fetchSponsors, 60000); // 60000 ms = 1 dakika

        // Bileşen unmount olduğunda intervali temizle
        return () => clearInterval(intervalId);

    }, []); // Boş bağımlılık dizisi, sadece ilk renderda çalışacak

    return (
        <div className='home-wrapper'>
            {/* Hero */}
            <section className='hero hero-section'>
                <Container>
                    <Row className="justify-content-md-center align-items-center">
                        <Col md={5} lg={4}>
                            <h1 className='hero-title mb-3'>
                                Kurumunuzun IT ihtiyaçlarına <span>yenilikçi</span> çözümler sunuyoruz.
                            </h1>
                        </Col>
                        <Col md={7} lg={6}>
                            <div className='home-svg'>
                                <SvgMeeting />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
{/*
             STOYS
            <HomeSection
                title="K12 ÇÖZÜMLERİ -"
                subtitle="STOYS"
                description={`STOYS’un kusursuz çalışmasını sağlayan gizli gücü içerisinde barındırdığı çarkların
          birbirleriyle mükemmel uyumundan gelmektedir. STOYS’a veri bir kere girilir ve çarklar
          çalışmaya başlayarak bu veriyi tüm modüllere erişilebilir kılar.`}
                link="/cozumlerimiz/stoys"
                buttonVariant="light"
                SvgComponent={SvgKids}
                left
            />

             OIS
            <HomeSection
                title="ÜNİVERSİTE ÇÖZÜMLERİ -"
                subtitle="OİS"
                description={`Üniversitelerin farklı alanlardaki işleyişi, OİS modülleri ile tek sistem altında birleşir.
        OİS, işlevselliği, anında destek özelliği, müşteri memnuniyeti, teknoloji uyumluluğu, OİS ekibinin sunduğu pratik çözümler gibi birçok konuda ayrıcalık gösterir.`}
                link="/cozumlerimiz/ois"
                buttonVariant="secondary"
                SvgComponent={SvgLearning}
            />

             ACADEMY CALL
            <HomeSection
                title="ÇAĞRI MERKEZİ ÇÖZÜMLERİ -"
                subtitle="ACADEMY CALL"
                description={`AcademyCall Türkiye’nin eğitim alanında profesyonel olarak hizmet veren ilk ve tek çağrı merkezidir.
        İnsan kaynağı, teknolojik alt yapı ve raporlama performansımız ile hizmet verdiğimiz eğitim kurumlarına yüksek oranda verimlilik, tasarruf ve marka değerine önemli oranda katkı sağlamaktayız.`}
                link="/cozumlerimiz/academy-call"
                buttonVariant="light"
                SvgComponent={SvgAcademyCall}
                left
            />

             ONEXA & EASY QUIZ
            <section className='home-section'>
                <Container>
                    <Row className='justify-content-md-center'>
                        <Col md={7} lg={6}>
                            <h4 className='mb-3 text-success'>E-SINAV ÇÖZÜMLERİ -</h4>
                            <h2>ONEXA</h2>
                            <p className='mb-4'>
                                Onexa kullanıcı dostu arayüzü sayesinde soru girişlerinin kolay bir şekilde yapılmasını sağlar.
                                Aynı anda onbinlerce kişinin sınav olabildiği sistemde farklılaştırılmış arayüzler kullanılmaktadır.
                            </p>
                            <Link to="/cozumlerimiz/onexa">
                                <Button variant="secondary" className='d-flex align-items-center btn-icon mb-3'>
                                    <IconArrowRight size={18} />
                                </Button>
                            </Link>

                            <h2>EASY QUIZY</h2>
                            <p>
                                Easy Quiz, sadece çoktan seçmeli testler için geliştirilmiş, kolay kullanım sağlayan bir sınav sistemidir.
                            </p>
                            <Link to="/cozumlerimiz/easy-quiz">
                                <Button variant="secondary" className='d-flex align-items-center btn-icon'>
                                    <IconArrowRight size={18} />
                                </Button>
                            </Link>
                        </Col>
                        <Col md={5} lg={4}>
                            <div className='home-section-svg'>
                                <SvgTest />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>*/}

            {/* Sponsor Markalar */}
            <section className='home-section'>
                <Container>
                    <Row className='justify-content-md-center'>
                        <Col md={10}>
                            <div className="brand-items-wrapper d-flex flex-wrap">
                                {!loading && sponsors.slice(0, 7).map((item, i) => (
                                    <div className='brand-items' key={i}>
                                        <img className='sponsor-image' src={item.image} alt={item.title} />
                                        <span>{item.title}</span>
                                    </div>
                                ))}
                                <Link to="/kurumlar">
                                    <div className='brand-items brand-all-items'>
                                        <IconArrowRight size={32} />
                                    </div>
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}

// ALT BİLEŞEN: Tekrarlayan bölüm yapısı
function HomeSection({ title, subtitle, description, link, buttonVariant, SvgComponent, left = false }) {
    return (
        <section className='home-section'>
            <Container>
                <Row className='justify-content-md-center align-items-center'>
                    {left && (
                        <Col md={6} lg={5}>
                            <div className='home-section-svg'>
                                <SvgComponent />
                            </div>
                        </Col>
                    )}
                    <Col md={6} lg={6}>
                        <h4 className='mb-3'>{title}</h4>
                        <h2>{subtitle}</h2>
                        <p className='mb-3'>{description}</p>
                        <Link to={link}>
                            <Button variant={buttonVariant} className='d-flex align-items-center btn-icon'>
                                <IconArrowRight size={18} />
                            </Button>
                        </Link>
                    </Col>
                    {!left && (
                        <Col md={5} lg={4}>
                            <div className='home-section-svg'>
                                <SvgComponent />
                            </div>
                        </Col>
                    )}
                </Row>
            </Container>
        </section>
    );
}

export default Home;
